import type { ErrorHandler } from '@awaze/mfe-common.contexts.tms'
import { CORRELATION_ID_COOKIE_NAME } from 'src/constants'
import { getCookie } from '../helpers'

export const dataLayerErrorHandler: ErrorHandler = (error: string) => {
  if (typeof newrelic !== 'undefined') {
    const correlationId = getCookie(CORRELATION_ID_COOKIE_NAME)
    newrelic.noticeError(error, correlationId ? { correlationId } : null)
  }
}
